import { createSelector } from 'reselect'

import { getMenus } from 'store/Menus/selectors'
import { getRevenueCenters } from 'store/RevenueCenters/selector'

export const getMerchants = (state) =>
  Object.values(state.merchants.byId)

export const getMerchant = (state, uuid) =>
  state?.merchants?.byId[uuid] ?? {}

export const getIsMerchantsLoading = (state) =>
  state?.merchants?.isLoading ?? false

export const getAllMerchantsCount = (state) =>
  state?.merchants?.allMerchantsCount ?? 0

export const getAssignedRevenueCentersToMerchant = createSelector(
  getMerchant,
  getRevenueCenters,
  (merchant, revenueCenters) => {
    const assignedRevenueCenters = revenueCenters.filter(
      ({ merchantId }) => merchantId === merchant.uuid
    )

    return assignedRevenueCenters.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    )
  }
)

export const getAssignedMenusToMerchant = createSelector(
  getMerchant,
  getMenus,
  (merchant, menus) => {
    const assignedMenus = menus.filter(
      ({ merchantId }) => merchantId === merchant.uuid
    )

    return assignedMenus.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    )
  }
)
